module.exports = __webpack_public_path__ + "static/media/archive-1.e3b1a01c.svg";